import React from "react";
import _ from "lodash";
import autoBind from "react-autobind";
import { branch } from "baobab-react/higher-order";
import PropTypes from "baobab-react/prop-types";

import { Button } from "react-bootstrap";
import Flexbox from "flexbox-react";
import FontAwesome from "react-fontawesome";
import ActivityPlayer from "./ActivityPlayer";

import * as playerActions from "../../actions/playerActions";
import Alerts from "../../components/Alerts.js";
import Loader from "../shared/loader";
import { isInIFrame, handleLaunchInNewTab } from "../../utils/utils";
import { getConfigParam } from "../../utils/config";
import { getActivityMetaData } from "../../utils/utils";

class PlayerProcedure extends React.PureComponent {

	constructor(props) {
		super(props);
		autoBind(this);
	}

	handleSave() {
		this.props.dispatch(
			playerActions.saveActivity
		);
	}

	handleSaveAndExit() {
		this.props.dispatch(
			playerActions.saveActivityAndExit
		);
	}

	handleExit() {
		this.props.dispatch(
			playerActions.exit
		);
	}

	handleExpandAll() {
		this.props.dispatch(
			playerActions.expandAll
		);
	}

	handleCollapseAll() {
		this.props.dispatch(
			playerActions.collapseAll
		);
	}

	handleGoBackFromLink() {
		this.props.dispatch(
			playerActions.goBackFromLink
		);
	}

	handleBackDismiss() {
		this.props.dispatch(
			playerActions.goBackDismiss
		);
	}

	handleNavigateNext() {
		this.props.dispatch(
			playerActions.gotoNextItem
		)
	}

	handleNavigatePrevious() {
		this.props.dispatch(
			playerActions.gotoPreviousItem
		)
	}

	handleCheck() {
		this.props.dispatch(
			playerActions.setNextItemChecked
		)
	}

	handleOpenInNewTab() {
		handleLaunchInNewTab();
	}


	handleReplay() {
		this.props.dispatch(
			playerActions.clearCurrentActivityNoConfirm
		)
	}

	render() {
		let activity;
		let activityMetaData = getActivityMetaData(this.props.activity.id);
		let trackData = activityMetaData.trackData;

		if (_.isEmpty(this.props.activity)) {
			activity = <div></div>;
		} else {
			activity = <ActivityPlayer readOnly={this.props.readOnly} activity={this.props.activity} showAcceptDefaultButton={true} showMode={false} />;
		}

		let goBackControl = <div></div>;
		let goBackControlAbsolute = <div></div>;
		if (this.props.navStack.length > 0) {
			goBackControl =
				<div className="player-go-back-control">
					<Button bsStyle="primary" style={{ marginRight: "4px" }} onClick={this.handleGoBackFromLink}><FontAwesome name="chevron-left" />&nbsp;&nbsp;GO BACK</Button>
					<FontAwesome name="times" onClick={this.handleBackDismiss} className="player-go-back-control-close" />
				</div>;
			goBackControlAbsolute =
				<div className="player-go-back-control absolute">
					<Button bsStyle="primary" style={{ marginRight: "4px" }} onClick={this.handleGoBackFromLink}><FontAwesome name="chevron-left" />&nbsp;&nbsp;GO BACK</Button>
					<FontAwesome name="times" onClick={this.handleBackDismiss} className="player-go-back-control-close" />
				</div>;
		}

		/*
		var classPlayerButtonsContainer = "player-buttons-container";
		if (this.props.activity.firstLevel === "items") {
			classPlayerButtonsContainer = "player-buttons-container-hidden"
		}
		*/

		const iframe = isInIFrame();
		const showControls = getConfigParam("showControls");

		const showHeaderPanel = getConfigParam("showHeaderPanel", true);
		const isNonDefaultPersistence = this.props.persistenceType.toLowerCase() !== "default";
		const expandCollapseAvailable = this.props.activity.firstLevel === "lists" || this.props.activity.firstLevel === "sections";
		let page = <Flexbox flexDirection="column" style={{ overflowY: "hidden" }}>
			<Alerts />
			<Flexbox flex="1" flexDirection="column" width="100%" style={{ minHeight: 0, paddingTop: iframe && showHeaderPanel ? "50px" : 0, paddingBottom: showControls ? "50px" : 0 }} className="player-container">
				{
					/*
					!showHeaderPanel && <div style={{ position: "fixed", top: 0, left: 0, width: "100%", right: 0, height: "50px", zIndex: 999, backgroundColor: "rgba(0,0,0,.8)", color: "white", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
					{goBackControl}
					{(this.props.activity.firstLevel === "lists" || this.props.activity.firstLevel === "sections") &&
						<div style={{ display: "flex", flexDirection: "row", alignItems: "flex-start", alignContent: "flex-start", marginRight: "10px" }}>
							<Button title="Expand all" bsStyle="primary" onClick={this.handleExpandAll} style={{ marginRight: "10px" }}><FontAwesome name="expand" /></Button>
							<Button title="Collapse all" bsStyle="primary" onClick={this.handleCollapseAll} style={{ marginRight: "10px" }}><FontAwesome name="compress" /></Button>
							{isNonDefaultPersistence &&
								<div>
									{trackData !== false && <Button bsStyle="primary" onClick={this.handleSave} style={{ marginRight: "10px" }}>Save</Button>}
									{trackData !== false && <Button bsStyle="primary" onClick={this.handleSaveAndExit}>Save + Exit</Button>}
									{trackData === false && <Button bsStyle="primary" onClick={this.handleExit}>Exit</Button>}
								</div>
							}
						</div>
					}				
					</div>
					*/
				}
				{showHeaderPanel && <div style={{ position: "fixed", top: 0, left: 0, width: "100%", right: 0, height: "50px", zIndex: 999, backgroundColor: "rgba(0,0,0,.8)", color: "white", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
					<div style={{ color: "white", fontWeight: 600, fontSize: "11px", paddingLeft: "10px", fontFamily: "'Thasadith', sans-serif" }}>Powered By<br /><a href="https://www.ambifi.com"><img src="./ambifi-logo-powered-by.png" alt="AmbiFi Logo" style={{ width: "78px", height: "25px", marginLeft: "-5px" }} /></a></div>
					{goBackControl}
					<div style={{ display: "flex", justifyContent: "center", alignItems: "center", paddingRight: "10px" }}>
						{(expandCollapseAvailable || isNonDefaultPersistence) &&
							<div style={{ display: "flex", flexDirection: "row", alignItems: "flex-start", alignContent: "flex-start", marginRight: "10px" }}>
							{expandCollapseAvailable && <Button title="Expand all" bsStyle="primary" onClick={this.handleExpandAll} style={{ marginRight: "10px" }}><FontAwesome name="expand" /></Button>}
							{expandCollapseAvailable && <Button title="Collapse all" bsStyle="primary" onClick={this.handleCollapseAll} style={{ marginRight: "10px" }}><FontAwesome name="compress" /></Button>}
							{isNonDefaultPersistence &&
								<div>
									{trackData !== false && <Button bsStyle="primary" onClick={this.handleSave} style={{ marginRight: "10px" }}>Save</Button>}
									{trackData !== false && <Button bsStyle="primary" onClick={this.handleSaveAndExit}>Save + Exit</Button>}
									{trackData === false && <Button bsStyle="primary" onClick={this.handleExit}>Exit</Button>}
								</div>
							}
							</div>
						}
						<Button title="Reset and restart" onClick={this.handleReplay} ><FontAwesome name="repeat" /></Button>
						<Button title="Play in new tab" style={{ marginLeft: "5px" }} onClick={this.handleOpenInNewTab}><FontAwesome name="external-link" /></Button>
					</div>
				</div>}
				<div className="player-activity-container">
					{activity}
				</div>
			</Flexbox>
			{showControls && <div style={{ position: "fixed", bottom: 0, left: 0, width: "100%", right: 0, height: "50px", zIndex: 999, backgroundColor: "rgba(0,0,0,.4)", color: "white", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
				<div style={{ paddingLeft: "10px" }}>{goBackControl}</div>
				<div />
				<div style={{ display: "flex", justifyContent: "center", alignItems: "center", paddingRight: "10px" }}>

					{isNonDefaultPersistence && trackData !== false && <Button style={{ marginRight: "5px" }} bsStyle="primary" onClick={this.handleSave}>Save</Button>}
					{isNonDefaultPersistence && trackData !== false && <Button style={{ marginRight: "15px" }} bsStyle="primary" onClick={this.handleSaveAndExit}>Save + Exit</Button>}
					{isNonDefaultPersistence && trackData === false && <Button style={{ marginRight: "15px" }} bsStyle="primary" onClick={this.handleExit}>Exit</Button>}

					<Button style={{ marginRight: "5px" }} disabled={!this.props.activity.hasPrevious} onClick={this.handleNavigatePrevious}><FontAwesome name="chevron-up" /></Button>
					<Button style={{ marginRight: "15px" }} disabled={!this.props.activity.hasNext} onClick={this.handleNavigateNext}><FontAwesome name="chevron-down" /></Button>

					<Button bsStyle="success" onClick={this.handleCheck}><FontAwesome name="check" /></Button>
				</div>
			</div>}
			{!showControls && goBackControlAbsolute}
			<Loader fullPage show={this.props.showSpinner} />
		</Flexbox>;

		return page;
	}
}

PlayerProcedure.contextTypes = {
	tree: PropTypes.baobab
};

export default branch({
	activity: ["activity"],
	navStack: ["player", "navStack"],
	showSpinner: ["player", "showSpinner"],
	readOnly: ["player", "readOnly"],
	persistenceType: ["appState", "targetConfig", "type"]
}, PlayerProcedure);